;
define("locator_venue_details.tpl", function(){});

